<nav class="nav-serv">
  <ul>
    <li routerLinkActive="current" *ngFor="let seccion of secciones">
      <a title="{{ seccion.nombre | translate }}" (click)="navegar(seccion.url)">{{
        seccion.nombre | translate
      }}</a>
    </li>
  </ul>
</nav>
<button type="button" class="CancelButton" (click)="cancelarVenta()" title="Cancelar">
  {{ 'CANCELAR' | translate }}
</button>

<form #formsub id="AgendaForm" method="post" [action]="this.urlAgenda" target="Agenda"> 
  <input type="hidden"  name="hdargumentos" value="something"/>
  <input type="hidden" name="hdcallagenda" value="CallAgenda" />
</form>
<form #formadmin id="AdminForm" method="post" [action]="this.urladmin" target="Admin"> 
  <input type="hidden"  name="hdargumentos" value="something"/>
</form>